const accordions = document.querySelectorAll('.accordion');

accordions.forEach((accordion) => {
    const items = accordion.querySelectorAll('.accordion__item');

    items.forEach((el) => {

        el?.addEventListener('click', (e) => {
            toggleAccordionItem(el, accordion);
        });
    });
});

function toggleAccordionItem(item, accordion) {

    // Close all other items
    const items = accordion.querySelectorAll('.accordion__item');
    items.forEach((el) => {
        if (el !== item) {
            el.dataset.state = 'closed';
        }
    });

    // Toggle the clicked item
    const state = item.dataset.state;
    if (state == 'opened') {
      item.dataset.state = 'closed';
    } else if (state == 'closed') {
      item.dataset.state = 'opened';
    }
}